import React, { Component } from 'react';
import styles from './styles';

import { AxlInput, AxlPanel, AxlButton } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

import _ from 'lodash';

@inject('deliveryStore')
@observer
class ShipmentCustomerForm extends Component {
  state = {
    updating: false,
    errors: {},
    oldValue: {},
    responseError: {
      code: '',
      msg: '',
    }
  };

  componentDidMount() {
    const { shipmentCustomerForm } = this.props.deliveryStore;
    const name = shipmentCustomerForm.getField('name', '').trim();
    const email = shipmentCustomerForm.getField('email', '').trim();
    const phoneNumber = shipmentCustomerForm.getField('phone_number', '').trim();

    this.setState({
      oldValue: {
        name, email,
        phone_number: phoneNumber,
      }
    })
  }

  componentDidUpdate() {
    const { shipmentCustomerForm } = this.props.deliveryStore;
    const { errors } = this.state;
    let needUpdate = false;
    const name = shipmentCustomerForm.getField('name', '').trim();

    if (name === '' && !errors.name) {
      needUpdate = true;
      _.set(errors, 'name', 'This field cannot empty!');
    } else if (name !== '' && errors.name) {
      needUpdate = true;
      _.set(errors, 'name', '');
    }

    if (needUpdate) {
      this.setState({errors})
    }
  }

  getFormErrors = (name) => {
    return _.get(this.state.errors, name, '');
  };

  closeWithoutSave = () => {
    const { shipmentCustomerForm } = this.props.deliveryStore;
    const { oldValue } = this.state;

    ['name', 'email', 'phone_number'].forEach(
      name => shipmentCustomerForm.setField(name, oldValue[name])
    );
    this.props.closeForm();
  };

  save = (e) => {
    const {deliveryStore, shipment, closeForm} = this.props;
    if (shipment.customer !== undefined && shipment.customer.phone_number === '') {
      shipment.customer.phone_number = undefined;
    }

    if (!Object.values(this.state.errors).filter(e => e).length) {
      this.setState({updating: true});
      deliveryStore.updateShipmentCustomer(shipment, (res) => {
        this.setState({updating: false});
        if (res.ok) {
          this.setState({responseError: {code: '', msg: ''}});
          closeForm();
        } else {
          this.setState({
            responseError: {
              code: res.status,
              msg: res.data && res.data.errors ? res.data.errors.join(' ') : 'Fail to save customer info. Try again.'
            }
          })
        }
      });
    }
  };

  render() {
    const { deliveryStore } = this.props;
    const { shipmentCustomerForm } = deliveryStore;
    const { responseError } = this.state;

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Edit Customer`}</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
              <div style={styles.Field}>
                <AxlInput
                  value={shipmentCustomerForm.getField('name', '')}
                  onChange={shipmentCustomerForm.handlerInput}
                  error={this.getFormErrors('name')}
                  placeholder={`Name`}
                  name={`name`}
                  type={`text`}
                  fluid
                />
              </div>
              <div style={styles.Field}>
                <AxlInput
                  value={shipmentCustomerForm.getField('email', '')}
                  onChange={shipmentCustomerForm.handlerInput}
                  error={this.getFormErrors('email')}
                  placeholder={`Email Address`}
                  name={`email`}
                  type={`email`}
                  fluid
                />
              </div>
              <div style={styles.Field}>
                <AxlInput
                  value={shipmentCustomerForm.getField('phone_number', '')}
                  onChange={shipmentCustomerForm.handlerInput}
                  error={this.getFormErrors('phone_number')}
                  placeholder={`Phone Number`}
                  name={`phone_number`}
                  type={`text`}
                  fluid
                />
              </div>
            </div>
            {responseError.code !== '' && (
              <div style={styles.error}>
                {`Error ${responseError.code}: ${responseError.msg}`}
              </div>
            )}
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`gray`}
                           onClick={this.closeWithoutSave}
                           style={styles.buttonControl}
                >
                  {`Cancel`}
                </AxlButton>
              </div>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`pink`}
                           onClick={this.save}
                           style={styles.buttonControl}
                           loading={this.state.updating}
                >
                  {`Save`}
                </AxlButton>
              </div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentCustomerForm;